import { productLink } from "@components/config/helpers";

const CategorySchema = ({ categoryData, category_products, long_term = false }) => {
    const { category } = categoryData;
    //   TODO add url
    var product_list = [];
    var base_url = process.env.BASE_URL;
    // if (typeof window !== "undefined") {
    //     console.log(window.origin);
    // } else {
    //     console.log("undefined");
    // }
    category_products.map((product, idx) => {
        const product_link = productLink(product.canonical_category_slug, product.product_slug, long_term);
        const json_obj = {
            "@type": "ListItem",
            position: (idx + 1).toString(),
            url: base_url + product_link,
            name: product.name,
            image: {
                "@type": "ImageObject",
                url: product.image,
            },
        };
        product_list.push(json_obj);
    });
    const categoryJsonld = {
        __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "ItemList",
            name: category.name,
            description: category.description_short,
            numberOfItems: product_list.length.toString(),
            itemListElement: product_list,
        }),
    };
    return (
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={categoryJsonld}
            id="category-jsonld"
            key="category-jsonld"
        />
    );
};

export default CategorySchema;
